import { useEffect, useRef, useState } from 'react';
const SWATCHES = [
    { value: 'transparent', label: 'Transparent', css: 'transparent' },
    { value: '#ffffff', label: 'White', css: '#ffffff' },
    { value: '#000000', label: 'Black', css: '#000000' },
    { value: '#1e3a8a', label: 'Blue', css: '#1e3a8a' },
];
export default function ResultView({ cutout, originalUrl, backdrop, onBackdrop }) {
    const canvasRef = useRef(null);
    const [split, setSplit] = useState(55);
    // Repaint whenever the cutout or chosen backdrop changes.
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        canvas.width = cutout.width;
        canvas.height = cutout.height;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        ctx.clearRect(0, 0, cutout.width, cutout.height);
        if (backdrop !== 'transparent') {
            ctx.fillStyle = backdrop;
            ctx.fillRect(0, 0, cutout.width, cutout.height);
        }
        // A fresh copy: putImageData would otherwise overwrite the fill we just made.
        const tmp = new OffscreenCanvas(cutout.width, cutout.height);
        const tctx = tmp.getContext('2d');
        if (!tctx)
            return;
        tctx.putImageData(new ImageData(cutout.rgba, cutout.width, cutout.height), 0, 0);
        ctx.drawImage(tmp, 0, 0);
    }, [cutout, backdrop]);
    return (<>
      <div className="stage">
        {/* Bottom layer: the original, revealed to the left of the divider. */}
        <img src={originalUrl} alt="Original"/>

        {/* Top layer: the cutout, clipped to the right of the divider. */}
        <div className={`layer${backdrop === 'transparent' ? ' checker' : ''}`} style={{ clipPath: `inset(0 0 0 ${split}%)` }}>
          <canvas ref={canvasRef}/>
        </div>

        <div className="divider" style={{ left: `${split}%` }}/>
        <input className="slider" type="range" min={0} max={100} step={0.5} value={split} aria-label="Compare original and cutout" onChange={(e) => setSplit(Number(e.target.value))}/>
      </div>

      <div className="row" style={{ marginTop: 14, justifyContent: 'space-between' }}>
        <div className="swatches">
          <span className="meta" style={{ marginRight: 4 }}>
            Background
          </span>
          {SWATCHES.map((s) => (<button key={s.value} className={`sw${s.value === 'transparent' ? ' checker' : ''}`} style={s.value === 'transparent' ? undefined : { background: s.css }} aria-pressed={backdrop === s.value} aria-label={s.label} title={s.label} onClick={() => onBackdrop(s.value)}/>))}
        </div>
        <span className="meta">
          {cutout.width} &times; {cutout.height} &middot; {cutout.ms} ms &middot;{' '}
          {cutout.backend.toUpperCase()}
        </span>
      </div>
      {cutout.fellBackFrom && (<p className="warn" style={{ marginTop: 12 }}>
          This device could not run the HD model, so the fast model was used instead. You
          still get full resolution and edge cleanup.
        </p>)}

      <p className="meta" style={{ marginTop: 8 }}>
        Drag across the image to compare before and after.
      </p>
    </>);
}
